/**
 * RoGold - Level Up Roblox — Roblox site enhancer
 *
 * Its first web-accessible-resource entry — `svg/*`, `images/*.png`, `icons/*` and a
 * handful of named scripts (`retrieveGlobal.js`, `useAngular.js`, `init.js`) — is
 * matched to every origin with no `use_dynamic_url`, so those files are fetchable from
 * any page at a fixed URL. A second entry scopes one build-hashed inject script to
 * roblox.com only, which we leave alone.
 *
 * The grey icon is the cleanest signal: `icons/grey_128x128.png` is vendor-named and
 * loads through `probeImage` with no CORS grant, surviving a restrictive page CSP.
 *
 * Manifest verified against version 1.9.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'mafcicncghogpdpaieifglifaagndbni';

export const roGold: ExtensionDefinition = {
  id: ID,
  name: 'RoGold - Level Up Roblox',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 700_000,
  notes:
    'Exposes svg/, icons/ and named scripts to every origin with no dynamic URL. The ' +
    'icon image is conclusive and needs no CORS grant; retrieveGlobal.js corroborates.',
  signals: [
    {
      id: 'war-grey-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load icons/grey_128x128.png via <img> — a vendor-named toolbar icon exposed to ' +
        'every origin; needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'icons/grey_128x128.png'),
    },
    {
      id: 'war-icons-svg',
      kind: 'web-accessible-resource',
      description:
        'Load svg/icons.svg via <img> — the vendor icon sprite, a second image path ' +
        'corroborating the identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'svg/icons.svg'),
    },
    {
      id: 'war-retrieve-global-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch retrieveGlobal.js — a named injection script exposed to every origin, an ' +
        'independent non-image path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'retrieveGlobal.js'),
    },
  ],
};
